module.exports = __webpack_public_path__ + "img/complete.146cd002.svg";